// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import vSelect from 'vue-select'
import * as Config from './config';
import Tippy from 'v-tippy'
import VueProgressiveImage from 'vue-progressive-image'

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

// include styles for plugins
import 'v-tippy/dist/tippy.css'
import 'vue-select/dist/vue-select.css';

Vue.use(VueProgressiveImage)

//  use Sweetalert
Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect)
Vue.use(Tippy)

import linkify from 'vue-linkify'
Vue.directive('linkified', linkify)

import { CalendarHeatmap } from 'vue-calendar-heatmap'
Vue.component('calendarHeatmap', CalendarHeatmap)


Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
